module.exports = __webpack_public_path__ + "img/earphones.62724f3c.svg";